import { useEffect, useState } from "react";
import { deviceApi } from "@/api";
import { toast } from "sonner";
import { STATUS_ORDER, VEHICLE_STATUSES } from "@/lib/constants";
import { X, ChevronDown } from "lucide-react";

export function VehicleStatusButton({ vehicle, onChanged, currentIncidentId }) {
  const [open, setOpen] = useState(false);
  const [incidents, setIncidents] = useState([]);
  const [incidentId, setIncidentId] = useState(currentIncidentId || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    deviceApi.get("/incidents/mine").then(({ data }) => {
      setIncidents(data);
      if (data.length) setIncidentId((prev) => prev || currentIncidentId || data[0].id);
    }).catch(() => {});
  }, [open]); // eslint-disable-line

  const choose = async (s) => {
    if (!vehicle) return;
    setBusy(true);
    try {
      const { data } = await deviceApi.post(`/vehicles/${vehicle.id}/status`, { status: s, incident_id: incidentId || null });
      toast.success(`Status: ${VEHICLE_STATUSES[s].label}`);
      onChanged && onChanged(data);
      setOpen(false);
    } catch (err) { toast.error(err.response?.data?.detail || "Mislukt"); }
    finally { setBusy(false); }
  };

  if (!vehicle) return null;
  const cur = VEHICLE_STATUSES[vehicle.status];
  return (
    <>
      <button data-testid="vehicle-status-btn" onClick={() => setOpen(true)}
        className="flex w-full items-center justify-between gap-2 rounded-2xl border-2 px-4 py-3.5 text-base font-bold active:scale-95"
        style={{ backgroundColor: cur?.hex || "#0f172a", color: "#fff", borderColor: cur?.hex || "#0f172a" }}>
        <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full bg-white/90" /> Status: {cur?.label || vehicle.status}</span>
        <ChevronDown className="h-5 w-5" />
      </button>

      {open && (
        <div className="fixed inset-0 z-[2000] flex items-end justify-center bg-black/60 p-4 sm:items-center" onClick={() => setOpen(false)} data-testid="vehicle-status-modal">
          <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
            <div className="mb-3 flex items-center justify-between">
              <div className="text-sm font-bold text-slate-900">Status wijzigen</div>
              <button onClick={() => setOpen(false)} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100"><X className="h-5 w-5" /></button>
            </div>
            {incidents.length > 1 && (
              <div className="mb-3">
                <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">Voor welk incident?</div>
                <div className="space-y-1.5">
                  {incidents.map((i) => (
                    <label key={i.id} data-testid={`status-incident-${i.id}`} className={`flex cursor-pointer items-center gap-2 rounded-xl border px-3 py-2 text-sm ${incidentId === i.id ? "border-blue-500 bg-blue-50" : "border-slate-200"}`}>
                      <input type="radio" name="status-incident" checked={incidentId === i.id} onChange={() => setIncidentId(i.id)} />
                      <span className="font-mono text-xs text-slate-400">{i.ref}</span>
                      <span className="truncate font-semibold text-slate-800">{i.title}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div className="grid grid-cols-2 gap-2.5">
              {STATUS_ORDER.filter((s) => s !== "gealarmeerd").map((s) => (
                <button key={s} data-testid={`status-opt-${s}`} disabled={busy} onClick={() => choose(s)}
                  className="flex min-h-[52px] items-center justify-center rounded-2xl border-2 px-3 text-sm font-bold active:scale-95 disabled:opacity-60"
                  style={{ backgroundColor: vehicle.status === s ? VEHICLE_STATUSES[s].hex : VEHICLE_STATUSES[s].bg, color: vehicle.status === s ? "#fff" : VEHICLE_STATUSES[s].text, borderColor: vehicle.status === s ? VEHICLE_STATUSES[s].hex : VEHICLE_STATUSES[s].border }}>
                  {VEHICLE_STATUSES[s].label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
